// extracted by mini-css-extract-plugin
export var avatar = "_qu-3";
export var avatarContainer = "_qu-2";
export var avatarSpacer = "_qu-5";
export var avatarSpacerContainer = "_qu-4";
export var avatarStackContainer = "_qu-1";
export var bubble = "_qu-0";
export var remainderBubble = "_qu-6";